<template>
    <div class="container mt-5">

    <router-link class="btn-back" to="/solutions/marketplace"><i class="fas fa-long-arrow-alt-left"></i> Retourner à la page précédente</router-link>
    <div class="titleProduct">Dans ton Jardin</div>
    <div class="subTitle">La Boutique en ligne des amis du Jardin</div>
    
    <div class="row">
        <div class="col-md-6">
            <div class="highlighted">
                Le pari était osé, tant dans la dénomination du site que sur les délais de mise en ligne. 
            </div>
            Dans ton jardin est un site internet et une application mobile qui permettent, sur une sélection de magasins, d’accéder à une offre dédiée en fonction de la zone géographique de l’acheteur et des disponibilités produits dans les magasins autorisant le Click and Collect.
            Dans ton jardin met en avant une large gamme d’articles dédiés à l’entretien, aux plantations, aux animaux et à l’équipement du jardin en proposant les meilleurs prix, une sélection soignée des articles, des conseils !
        </div>
        <div class="col-md-6">
            <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/WyYblP1V0I4" allowfullscreen></iframe>
            </div>
        </div>
    </div>
    <div class="mt-4 mb-4">
       Le site intègre toutes les fonctionnalités d’une place de marché avec notamment un moteur de recherche performant, une classification des articles par catégorie, une messagerie instantanée permettant à l’acheteur d’être en contact avec le magasin, le paiement sécurisé, le click and collect et le processus d’information (Notifications, mails..) de mise à disposition des produits coté acheteur, une publication facilitée (via mobile) et un processus de facturation harmonisée avec la comptabilité interne coté vendeur.
       A son lancement, Dans ton jardin bénéficie de plus de 10 points de retrait sur la Champagne-Ardenne, les Hauts de France et la Seine et Marne, pour permettre aux clients d’aller chercher leurs commandes en toute facilité suivant le principe du Click & Collect. Bientôt, un service de livraison et de nouveaux fournisseurs pour répondre encore plus précisément à leurs besoins, leurs envies, et surtout pour leur faciliter la vie dans leur jardin. 
    </div>

    <div class="title">Clients et partenaires</div>
    <div class="row clients-logo text-center">
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/ceresia.png" alt=""></div>
    </div>
    
    <div class="row mt-5 mb-5 text-center">
        <a class="btn btn-secondary-outline ml-auto" href="www.danstonjardin.com" target="blank">Aller sur le Dans ton Jardin</a>
        <router-link class="btn btn-primary mr-auto" to="/contact"><i class="fas fa-long-arrow-alt-left"></i> Devenir partenaire</router-link>
    </div>

    <Contact/>

  </div>
</template>

<script >
    import Contact from '@/components/Contact'

    export default {
        name: 'DTJ',
        components:{
            Contact
        },
        props:{}
    }
</script>

<style lang="scss" scoped>


      .titleProduct{
        text-align: left;
        font-weight: 600;
        font-size: 55px;
        color: var(--mainBlue);
        padding-top: 50px;
    }

    .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }



</style>